<template>
  <section :class="classes">
    <slot />
  </section>
</template>

<script>
  const ALIGN = ['left', 'center', 'right'];
  const DIRECTION = ['horizontal', 'vertical'];
  const SIZE = ['medium', 'small'];

  export default {
    name: 'CordelButtonGroup',
    props: {
      align: {
        type: String,
        default: ALIGN[0],
        validator(value) {
          return ALIGN.includes(value);
        },
      },
      direction: {
        type: String,
        default: DIRECTION[0],
        validator(value) {
          return DIRECTION.includes(value);
        },
      },
      size: {
        type: String,
        default: SIZE[0],
        validator(value) {
          return SIZE.includes(value);
        },
      },
      mobile: {
        type: Boolean,
        default: false,
      },
      stretch: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      classes() {
        const classes = [
          'cordel-button-group',
          `direction--${this.direction}`,
          `align--${this.align}`,
          `size--${this.size}`,
        ];

        if (this.mobile) {
          classes.push('variant--mobile');
        }

        if (this.stretch) {
          classes.push('variant--stretch');
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss">
  .cordel-button-group {
    &.variant--stretch {
      .cordel-button {
        flex: 1;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-button-group {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1em;
  }

  .direction--horizontal {
    flex-direction: row;
  }

  .direction--vertical {
    flex-direction: column;
  }

  .align--left {
    justify-content: flex-start;
  }

  .align--center {
    justify-content: center;
  }

  .align--right {
    justify-content: flex-end;
  }

  .size--small {
    font-size: var(--cordel-legacy-font-size-s);
  }

  .variant--mobile,
  .variant--stretch {
    align-items: stretch;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      align-items: stretch;
      flex-direction: column;
    }
  }
</style>
